import actionCreatorFactory, { Action } from 'typescript-fsa'
import { Event } from 'typescript-fetch-api'

const actionCreator = actionCreatorFactory('Events')

export type CreateEventAction = Action<Event>
export const createEvent = actionCreator.async<Event, Response, Error>('CREATE_EVENT')